import tw from 'tailwind-styled-components'
import {cn} from '@containers/html-utils'

export const ByTimeContainer = tw.div`
  flex
  flex-col
  w-full
  h-full
`

export const ByTimeHeader = tw.div`
  mt-8
  flex
  w-full
  flex-wrap
`

export const ByTimeHeaderFilters = tw.div<{$smallScreen: boolean}>`
  flex
  gap-16
  items-center
  w-full
  py-8
  px-24
  
  ${({$smallScreen}) => ($smallScreen ? 'flex-wrap' : 'flex-nowrap')}
`

export const AdditionalFilters = tw.div`
  w-full
  bg-line-disabled
  rounded-8
  pt-12
  pb-8
  px-12
  mx-12
`

export const TwHeadTitle = tw.div`
  text-10
  leading-[16px]
  text-truncate
  text-center
  break-words
  line-clamp-3
`

export const ColumnTw = tw.div<{
  $highlighted?: boolean
  $currentLocation?: boolean
}>`
  w-full
  h-full
  flex
  items-center
  justify-center
  px-8
  text-truncate
  text-center
  break-words
  line-clamp-3
  text-14
  ${p => (p.$highlighted ? 'text-error-l20' : 'text-grey')}
  ${p => (p.$currentLocation ? 'bg-sticker-pink' : 'bg-transparent')}
`

export const TwCompletedSign = tw.div<{$completed?: boolean}>`
  h-24
  w-24
  min-h-24
  min-w-24
  -mx-4
  bg-no-repeat
  bg-center
  ${p =>
    cn(
      p.$completed &&
        cn('[background-image:url(/img/gtd/task-mark-active.svg)]'),
      !p.$completed && cn('[background-image:url(/img/gtd/task-mark.svg)]')
    )}
`

export const TwFilters = tw.div`
  flex
  flex-wrap
  gap-y-8
  items-center
  gap-16
  text-14
`

export const TwFilter = tw.div`
  flex
  flex-col
  gap-8
  text-secondary
`

export const TwResetBlock = tw.div`
  flex
  gap-16
  items-center
  text-12
  text-secondary
`
export const TwNotFound = tw.div`
  flex
  mt-32
  justify-center
  items-center
  flex-col
  gap-8
`

export const TwTaskNameTitle = tw.div<{
  $taskIsDone: boolean
  $taskIsOpened: boolean
}>`
  whitespace-nowrap
  group-hover:text-action-default
  text-ellipsis
  overflow-hidden
  mr-8
  text-14
  ${({$taskIsDone}) => ($taskIsDone ? 'text-grey-l20' : '')}
  ${({$taskIsOpened}) => ($taskIsOpened ? 'font-semibold' : '')}
`

export const TwSelected = tw.div`
  absolute
  bg-action-default
  top-0
  bottom-0
  w-4
  left-0
  rounded-l-12
`
